var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferSmallLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1008"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 492",
    d: "M32 14.999a4.76 4.76 0 00-1.857-3.831 4.293 4.293 0 01-2.292 1.951 4.17 4.17 0 002.334-3.718 4.237 4.237 0 00-4.3-4.182 2.839 2.839 0 00-.435.022 9.236 9.236 0 01.815 3.541H26.2a10.313 10.313 0 00-20.4 0h-.068a8.846 8.846 0 01.752-3.5A7.3 7.3 0 000 12.594a7.51 7.51 0 007.611 7.405h19.355v-.007A5.065 5.065 0 0032 14.999z",
    fill: "#17bed0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 494",
    d: "M16.138 17a.784.784 0 00.594-.266 2.169 2.169 0 00.417-.7l3.675-9.607a2.822 2.822 0 00.125-.389 1.464 1.464 0 00.044-.337.692.692 0 00-.191-.513.689.689 0 00-.508-.191 1.372 1.372 0 00-.34.047 3.938 3.938 0 00-.384.122l-9.66 3.7a1.94 1.94 0 00-.647.39.787.787 0 00-.263.6.712.712 0 00.291.631 2.492 2.492 0 00.725.326l2.761.848a1.42 1.42 0 00.53.081.8.8 0 00.437-.223l6.3-5.806a.161.161 0 01.245-.007.166.166 0 01.056.117.174.174 0 01-.056.134l-5.782 6.315a.766.766 0 00-.219.423 1.4 1.4 0 00.072.538l.816 2.7a2.84 2.84 0 00.333.756.7.7 0 00.629.311z",
    fill: "#fff"
  }))));
}
export default SvgTransferSmallLogo;